import { atom } from "recoil"
import { TemplateModel } from "src/types/contact/TemplateModel"

export const templateIdState = atom<TemplateModel["id"] | undefined>({
  key: "atoms/contact/create/templateIdState",
  default: undefined,
})
